import { useEffect, useState } from "react";

// The group a traveller is searching for, set by the group chat's "Search"
// button (owner, 2026-10-03): the site then says so, and "Share with my trip"
// shares straight into that group. Kept for this tab only, until the share
// is made or dropped. Only an id and a title: the dialog still checks the
// traveller's own groups before sharing anything.
const KEY = "toukky_share_target";
const listeners = new Set();
const notify = () => listeners.forEach((listener) => listener());

export function shareTarget() {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
    return saved && typeof saved.id === "string" && saved.id && typeof saved.title === "string" ? saved : null;
  } catch { return null; }
}

export function setShareTarget(group) {
  if (!group?.id) return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ id: String(group.id), title: String(group.title || "") })); } catch { /* this visit only */ }
  notify();
}

export function clearShareTarget() {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing kept */ }
  notify();
}

/** The group being searched for, kept in step with every change. */
export function useShareTarget() {
  const [target, setTarget] = useState(shareTarget);
  useEffect(() => {
    const listener = () => setTarget(shareTarget());
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }, []);
  return target;
}
